var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipo04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_2157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.1428,
    cy: 12,
    r: 12,
    fill: "#006768"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_263_2157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64292 17.3999C7.40292 17.3999 7.19292 17.3099 7.01292 17.1299C6.83292 16.9499 6.74292 16.7399 6.74292 16.4999V8.54993C6.74292 8.30993 6.83292 8.09993 7.01292 7.91993C7.19292 7.73993 7.40292 7.64993 7.64292 7.64993H9.29292C9.29292 6.85993 9.55792 6.18743 10.0879 5.63243C10.6179 5.07743 11.2779 4.79993 12.0679 4.79993C12.8579 4.79993 13.5429 5.07743 14.1229 5.63243C14.7029 6.18743 14.9929 6.85993 14.9929 7.64993H16.6429C16.8829 7.64993 17.0929 7.73993 17.2729 7.91993C17.4529 8.09993 17.5429 8.30993 17.5429 8.54993V16.4999C17.5429 16.7399 17.4529 16.9499 17.2729 17.1299C17.0929 17.3099 16.8829 17.3999 16.6429 17.3999H7.64292ZM7.64292 16.4999H16.6429V8.54993H7.64292V16.4999ZM12.1429 12.1499C12.9329 12.1499 13.6179 11.8599 14.1979 11.2799C14.7779 10.6999 15.0679 10.0149 15.0679 9.22493H14.1679C14.1679 9.77493 13.9679 10.2499 13.5679 10.6499C13.1679 11.0499 12.6929 11.2499 12.1429 11.2499C11.5929 11.2499 11.1179 11.0499 10.7179 10.6499C10.3179 10.2499 10.1179 9.77493 10.1179 9.22493H9.21792C9.21792 10.0149 9.50792 10.6999 10.0879 11.2799C10.6679 11.8599 11.3529 12.1499 12.1429 12.1499ZM10.1929 7.64993H14.0929C14.0929 7.09993 13.9054 6.63743 13.5304 6.26243C13.1554 5.88743 12.6929 5.69993 12.1429 5.69993C11.5929 5.69993 11.1304 5.88743 10.7554 6.26243C10.3804 6.63743 10.1929 7.09993 10.1929 7.64993ZM7.64292 16.4999V8.54993V16.4999Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_2157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.142822)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_263_2157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.94287 4.19995)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipo04);
export default __webpack_public_path__ + "static/media/tipo-04.962b008c193c421033edb840a22ea3cf.svg";
export { ForwardRef as ReactComponent };